// eslint-disable-next-line
export default function (Vue) {
  return {
    state: {},
    getters: {},
    mutations: {},
    actions: {},
  };
}
